import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  twitterCard?: string;
  schema?: Record<string, unknown>;
}

const defaultTitle = '芒果视频 - 蜜桃视频与糖豆视频之外好用的视频平台 | 芒果视频资源丰富推荐';
const defaultDescription = '芒果视频作为蜜桃视频、糖豆视频之外的优质推荐，资源丰富播放流畅。对比蘑菇视频、蓝莓视频，芒果视频App好用且免费高清，值得选择。';
const defaultKeywords = '芒果视频,芒果视频推荐,芒果视频好用吗,芒果视频资源,芒果视频App,蜜桃视频,糖豆视频,蘑菇视频,蓝莓视频,视频平台推荐,免费在线观看';
const defaultCanonical = 'https://www.mangoshipin.cn/';

export default function SEOHead({
  title = defaultTitle,
  description = defaultDescription,
  keywords = defaultKeywords,
  canonicalUrl = defaultCanonical,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogUrl,
  twitterCard = 'summary_large_image',
  schema,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (linkEl) {
      linkEl.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', ogTitle || title, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', ogUrl || canonicalUrl, true);
    setMeta('twitter:card', twitterCard, false);
    setMeta('twitter:title', ogTitle || title, false);
    setMeta('twitter:description', ogDescription || description, false);

    let schemaEl = document.querySelector('#jsonld-schema') as HTMLScriptElement | null;
    if (schema) {
      if (!schemaEl) {
        schemaEl = document.createElement('script');
        schemaEl.id = 'jsonld-schema';
        schemaEl.type = 'application/ld+json';
        document.head.appendChild(schemaEl);
      }
      schemaEl.textContent = JSON.stringify(schema);
    }
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogUrl, twitterCard, schema]);

  return null;
}